import { useRef, useEffect } from 'react'
import { useSimpleInactiveUpdate } from 'apps/builder/lib/hooks/inputHooks'

const placeholderText = 'Type your choice here and press Enter'

export const ChoiceOption = ({
  shouldGetFocus,
  setFocusIndex = () => {},
  text = '',
  onChange,
  onDelete,
  onEnter,
  onPaste,
  index,
  placeholder = placeholderText,
}) => {
  const {
    inputValue,
    handleChange, 
    handleBlur,
    cancelUpdate,
  } = useSimpleInactiveUpdate(text, onChange, 800)

  const inputRef = useRef()
  
  const change = ({ target }) => {
    const { value } = target
    handleChange(value)
  }

  useEffect(() => {
    if (shouldGetFocus) {
      const { current = {} } = inputRef
      current.focus()
      setFocusIndex(null)
    }
  }, [shouldGetFocus])

  const handleKeyDown = event => {
    const { key } = event
    const { current = {} } = inputRef
    if (key === 'Enter') {
      event.preventDefault()
      cancelUpdate()// prevent extra updates from blur
      onEnter(inputValue)// creates a new row
    }

    if (key === 'Backspace' && !inputValue) {
      event.preventDefault()
      cancelUpdate()// prevent extra updates from blur
      onDelete(index)// deletes this row
    }

    if (key === 'ArrowUp' && current.selectionStart === 0) {
      event.preventDefault()
      setFocusIndex(index - 1)
    } else if (
      key === 'ArrowDown'
      && current.selectionEnd === current.value.length) {
      event.preventDefault()
      setFocusIndex(index + 1)
    }
  }

  return (
    <input
      ref={inputRef}
      placeholder={placeholder}
      onKeyDown={handleKeyDown}
      onPaste={onPaste}
      onChange={change}
      onBlur={handleBlur}
      value={inputValue}
      type="text"
      className="option--input input--placeholder input__text input"
    />
  )
}
